import React from 'react';
import { InputTextarea } from 'primereact/inputtextarea';

export interface TextAreaProps
  extends Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'onChange'> {
  testId?: string;
  invalid?: boolean;
  /** Validation message; when present the field is styled as invalid. */
  error?: string;
  /** Optional field label rendered above the textarea. When set, the validation
   *  message (`error`) is shown beneath it. Omit it and the component renders
   *  exactly as before — a bare textarea. */
  label?: string;
  /** Marks the field required — renders a red asterisk after the label. */
  required?: boolean;
  /** Value-based change handler. */
  onChange?: (value: string) => void;
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({ testId, invalid, error, className, onChange, label, required, ...props }, ref) => {
    const control = (
      <InputTextarea
        ref={ref as any}
        data-testid={testId}
        className={`${className || ''} ${invalid || error ? 'p-invalid' : ''}`}
        onChange={(e) => onChange?.(e.target.value)}
        {...(props as any)}
      />
    );

    if (!label) {
      return control;
    }

    return (
      <div className="flex flex-col gap-1">
        <label className="text-sm font-medium text-slate-700 dark:text-slate-300">
          {label}{required && <span className="ml-1 text-red-500">*</span>}
        </label>
        {control}
        {error && <small className="text-rose-600 dark:text-rose-400">{error}</small>}
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';
export default TextArea;
